<template>
  <v-card class="overflow-hidden bg-gray-l br-0" style="height: 100%">
    <header>
      <slot name="header">
        <top-bar :title="title" v-on:openDrawer="onOpenDrawer"></top-bar>
      </slot>
    </header>
    <nav>
      <slot name="nav">
        <nav-drawer :open="drawer" v-on:closeDrawer="onCloseDrawer"></nav-drawer>
      </slot>
    </nav>
    <main>
      <slot name="main">
        <v-container class="br-wrapper bg-gray-l">
          <div class="body-wrapper p-b-70">
            <div class="authen-body-wrap">
              <div class="authen-body-wrapper m-b-20">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <slot></slot>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-container >          
      </slot>
    </main>
  </v-card>
</template>

<script>
import NavDrawer from '@/components/shared/NavDrawer.vue'
import TopBar from '@/components/shared/TopBar'


export default {
  name: 'Authenticated',
  components: { TopBar, NavDrawer },
  data: () => ({
    title: '',
    drawer: false
  }),
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    },
    onOpenDrawer(value) {
      this.drawer = value
    },
    onCloseDrawer(value) {
      this.drawer = value
    },
  },  
  mounted () {
    this.title = this.$route.meta.title
  },
}
</script>

<style scoped>
  @media only screen and (min-width: 767px) {
    .authen-body-wrapper {
      margin-top: 140px;
    }
  }
  .br-wrapper {
    margin-top: -7px;
  }
</style>